import { createAction, createAsyncAction } from 'typesafe-actions';
import { RelatedProducts } from './types';
import { ProductInSetClickType } from 'features/ga-events/messages/sets/types';
import { ProductMainInfoProps } from 'features/product-info/types';

export const FETCH_RELATED_PRODUCTS = createAsyncAction(
  'product/FETCH_RELATED_PRODUCTS/request',
  'product/FETCH_RELATED_PRODUCTS/success',
  'product/FETCH_RELATED_PRODUCTS/failure',
  'product/FETCH_RELATED_PRODUCTS/cancel',
)<void, RelatedProducts, Error, void>();

export const RESET_RELATED_PRODUCTS = createAction('product/RESET_RELATED_PRODUCTS')();

export const PRODUCT_IN_SET_CLICK = createAction('ui/PRODUCT_IN_SET_CLICK')<{
  elementName: ProductInSetClickType['elementName'];
  productInfo: ProductMainInfoProps;
  index: number;
}>();
export const PRODUCT_IN_SET_VIEW = createAction('ui/PRODUCT_IN_SET_VIEW')<{
  productInfo: ProductMainInfoProps;
  index: number;
}>();
